module.exports = __webpack_public_path__ + "img/Kamikaze.636e31dc.png";